import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../config/supabaseClient";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // onAuthStateChange prinde momentul exact când Supabase procesează token-ul
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (event === "SIGNED_IN" && session) {
          const pending = sessionStorage.getItem("pendingRoute");
          sessionStorage.removeItem("pendingRoute");
          navigate(pending || "/");
        }
      }
    );

    // Fallback — dacă sesiunea era deja activă înainte de redirect
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        const pending = sessionStorage.getItem("pendingRoute");
        sessionStorage.removeItem("pendingRoute");
        navigate(pending || "/");
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh"
    }}>
      <p>Se finalizează autentificarea...</p>
    </div>
  );
}